import Alpine from 'alpinejs';
import $ from "jquery";
import CartJS from 'shopify-cartjs';
window.jQuery = $;
CartJS.init(window.cartJSON);

export function MiniCart() {
    document.addEventListener('alpine:init', () => {
        document.addEventListener('click', (event) => {
            const link = event.target.closest('a[href*="#addToCart"]');
            
            if (link) {
                event.preventDefault();
                const currentItem = link.href.split('#addToCart-')[1].split('-');
                
                if (!currentItem[0] || !currentItem[1]) return;
                Alpine.store('cart').addToCart(currentItem[0], 1, currentItem[1]);
            }
        });
        
        const debounce = (func, wait) => {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        };

        Alpine.store('cart', {
            cartEl: $("#mini-cart"),
            items: CartJS.cart.items,
            regularItems: CartJS.cart.items.filter(item => !item?.selling_plan_allocation),
            subscriptionItems: CartJS.cart.items.filter(item => item?.selling_plan_allocation?.selling_plan?.id),
            subTotal: CartJS.cart.total_price / 100,
            itemsCount: CartJS.cart.item_count,
            isBuilderPage: document.querySelector('.builder') ? true : false,
            isOpen: false,
            cartError: '',
            totalSavings: 0,
            membershipState: false,
            thresholds: [],
            maxThreshold: 0,
            thresholdsSum: 0,
            currentThreshold: 0,
            frequencies: [],    
            thresholdGoalMessage: '',
            descriptionToggle: false,
            currentFrequency: 0,
            boxObject: JSON.parse(localStorage.getItem("boxObject")),
            addToBox(variantId, qty, maxQty) {
                qty = qty ? qty : 1;
                const sellingPlan = this.boxObject.sellingPlanGroup;
                const firstSellingPlan = sellingPlan ? this.clearId(Object.keys(sellingPlan)[0]) : false;

                let options = {
                    // '_max_qty': maxQty
                };

                if (firstSellingPlan) {
                    options.selling_plan = firstSellingPlan;
                }

                if (this.boxObject.boxId) {
                    // options._dynamicBoxIndex = 0;
                    // options._dynamicBoxId = this.boxObject.boxId;
                }

                CartJS.addItem(variantId, qty, options, 
                {
                    "success": (data, textStatus, jqXHR) =>{
                        this.isOpen = true;
                    },
                    "error": (jqXHR, textStatus, errorThrown) => {
                        const errorObject = JSON.parse(jqXHR.responseText);
                        this.cartError = errorObject?.description || 'Something went wrong';
                        console.log(this.cartError, 'error 222');
                    }
                });
            },
            addMembershipToCart() {
                const variantId = window.addMembershipToCartByDefault.id;
                const sellingPlan = window.addMembershipToCartByDefault.sellingPlan;

                if (!variantId || this.items.find(item => item.id == variantId)) return;
                
                this.addToCart(variantId, 1, sellingPlan, 0, true);
            },
            checkifMembershipProductInCart() {
                if (window.customerTags) {
                    const hasInveterateTier = window.customerTags.some(tag => tag.includes("inveterate-tier"));
                    this.membershipState = hasInveterateTier ? true : false;
                } else {
                    this.membershipState = this.items.find(item => item.id === window.memberShipProductVariantId) ? true : false;
                }
            },
            updateCurrentThreshold() {
                const currentBoxItemsPrice = this.subscriptionItems.reduce((acc, item) => acc + item.line_price, 0);
                const actualBoxItemsPrice = currentBoxItemsPrice / 100;

                this.currentThreshold = this.thresholds
                .filter(d => d.threshold <= actualBoxItemsPrice)
                .sort((a, b) => b.threshold - a.threshold)[0];
            },
            generateThresholds() {
                if (window.discountThresholds) {
                    this.thresholds = window.discountThresholds;
                } else {
                    this.thresholds = [];
                }

                this.thresholdsSum = this.thresholds.reduce((acc, curr) => +acc + +curr.threshold, 0);
                this.maxThreshold = this.thresholds.reduce((max, item) => (item.threshold > max ? item.threshold : max), -Infinity);
                
                this.updateCurrentThreshold();
            },
            currentProgress() {
                const currentBoxItemsPrice = this.subscriptionItems.reduce((acc, item) => acc + item.line_price, 0);
                const actualBoxItemsPrice = currentBoxItemsPrice / 100;
                const actualThreshold = this.thresholds.find(threshold => actualBoxItemsPrice < +threshold.threshold);

                this.thresholdGoalMessage = actualThreshold ? `Add <b>${this.currency()}${(actualThreshold.threshold - actualBoxItemsPrice).toFixed(2)}</b> more to your subscription for <b>${actualThreshold.value}% off</b>` : '';

                this.updateCurrentThreshold();
                
                return (currentBoxItemsPrice/100) / +this.maxThreshold * 100;
            },
            updateItemSellingPlan(itemId, sellingPlan) {
                CartJS.updateItemById(itemId, 1, { selling_plan: sellingPlan }, {
                    "success": (data, textStatus, jqXHR) => {
                        console.log('success');
                    }
                });
            },

            currentThresholdWidth(threshold) {
                const max = Math.max(...this.thresholds.map(t => t.threshold));
                return `${(threshold / max) * 100}`;
            },
            sortByPrice(items) {
                if (!items.length) return [];
                return items.sort((a, b) => a.price - b.price);
            },
            price(value) {
                return `${this.currency()}${((value / 100).toFixed(2))}`;
            },
    
            countSavings() {
                this.totalSavings = CartJS.cart.total_discount;
            },

            cartToggle(action) {
                if (action) {
                    this.cartEl.addClass('mini-cart--active');
                } else {
                    this.cartEl.removeClass('mini-cart--active');
                }
            },
            clearId(id) {
                return +id.replace('gid://shopify/SellingPlan/', '');
            },
            addToCart(variantId, quantity, sellingPlan, redirect, dontOpenAfterSuccess, properties) {
                let options = {};

                const activeQTY = quantity ? quantity : 1;

                if (sellingPlan) {
                    options.selling_plan = sellingPlan;
                }

                if (properties) {
                    options = properties;
                }

                CartJS.addItem(variantId, activeQTY, options, 
                {
                    "success": (data, textStatus, jqXHR) =>{
                        if (!dontOpenAfterSuccess) {
                            this.isOpen = true;
                        }
                        if (redirect) {
                            window.location.href = '/checkout';
                        }
                    },
                    "error": (jqXHR, textStatus, errorThrown) => {
                        this.cartError = jqXHR.responseJSON?.description;
                        console.log(jqXHR, 'error 222');
                    }
                });
            },
            addItems(items, redirect) {
                if (!items.length) return;

                CartJS.addItems(items, {
                    "success": (data, textStatus, jqXHR) =>{
                        if (redirect) {
                            window.location.href = '/checkout';
                        } else {
                            this.isOpen = true;
                        }
                    },
                    "error": (jqXHR, textStatus, errorThrown) => {
                        this.cartError = jqXHR.responseJSON.description;
                    }
                });
            },
            updateCart(cart) {
                if (!cart) {
                    cart = CartJS.cart;
                }
                this.items = cart.items;
                this.regularItems = cart.items.filter(item => !item?.selling_plan_allocation);
                this.subscriptionItems = cart.items.filter(item => item?.selling_plan_allocation);
                this.subTotal = cart.total_price / 100;
                this.itemsCount = cart.item_count;
                this.checkifMembershipProductInCart();
                this.countSavings();
                this.updateCurrentThreshold();

                if (this.isBuilderPage) {
                    Alpine.store('builder').syncQty();
                }
            },
            currency() {
                return this.getCurrencySymbol(CartJS.cart.currency);
            },

            decodeHtmlEntities(str) {
                const entities = {
                    "&amp;": "&",
                    "&lt;": "<",
                    "&gt;": ">",
                    "&quot;": "\"",
                    "&#39;": "'"
                };
                if (!str) return '';
                return str.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
            },

            getProductName(title) {
                const titleParts = title ?  title.split('|') :  false;
                const formattedTitle = titleParts ? this.decodeHtmlEntities(titleParts[0]) + ' | ' + this.decodeHtmlEntities(titleParts[1]) : '';
                return formattedTitle;
            },

            getSubtotal() {
                const subtotal = `${this.currency()}${CartJS.cart.total_price / 100}`;
                return subtotal;
            },
        
            getCurrencySymbol(currency) {
                const symbols = {
                    'USD': '$',
                    'EUR': '€',
                    'GBP': '£',
                    'RUB': '₽',
                    'JPY': '¥',
                    'CNY': '¥',
                };
                return symbols[currency] || currency;
            },

            updateItem: debounce((itemId, quantity) => {
                CartJS.updateItemById(itemId, quantity, {}, {
                    "success": (data, textStatus, jqXHR) => {
                        console.log('success');
                        // Alpine.store('cart').cartError = '';
                    },
                    "error": (jqXHR, textStatus, errorThrown) => {
                        // Alpine.store('cart').cartError = jqXHR.responseJSON.description;
                        console.log(jqXHR.responseJSON.description, 'error');
                    }
                }); 
            }, 500),

            removeItem(itemId) {
                CartJS.removeItemById(itemId);
                
                if (this.isBuilderPage) {
                    const parts = itemId.split(':');
                    console.log(parts, 'parts');
                    Alpine.store('builder').syncQty(parts[0]);
                }
            },
            init() {
                this.checkifMembershipProductInCart();
                this.countSavings();
                this.generateThresholds();

                if (window.addMembershipToCartByDefault) {
                    this.addMembershipToCart();
                }
            }
        });

        $(document).on('cart.requestComplete', function(event, cart) {
            Alpine.store('cart').updateCart(cart);
        });
    });
}